var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSlidesOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 37.129,
    viewBox: "0 0 41 37.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.6 -3.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1341.1-27.271V-58h34.721v30.733Zm2.933-2.932h28.856V-55.072h-28.856Zm34.134-3.872V-60.467H1347.9V-63.4h33.2v29.325Zm-24.4-1.056V-38.18h14.066v3.049Zm-6.568,0V-38.18h3.049v3.049Zm6.568-5.982v-3.049h14.066v3.049Zm-6.568,0v-3.049h3.049v3.049Zm6.568-6.1v-3.05h14.066v3.05Zm-6.568,0v-3.05h3.049v3.05Z",
    transform: "translate(-1338 67)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlidesOutline);
export default __webpack_public_path__ + "static/media/icon-slides-outline.481053b0.svg";
export { ForwardRef as ReactComponent };